import React from "react";
import Api from "./Api/Communicator";

export default class o2log extends React.Component {
  state = {
    errorTicketCnt: 0,
    successTicketCnt: 0,
    openTicketCnt: 0,
    selectGroup: 0,
    type: "",
    loading: false,
    searchModal: false,
    tickets: [],
    error: {
      show: false,
      text: "",
    },
    modal_doc: {
      open: false,
      type: "",
      data: {
        identifier: 0,
        caseNumber: null,
        sn_imei: null,
        sn_imei_new: null,
        status: null,
        substatus: null,
        statusDescription: null,
        productName: null,
        productNumber: null,
        warranty: null,
        result: null,
        shipmentIn: {
          company: null,
          number: null,
        },
        shipmentOut: {
          company: null,
          number: null,
          price: 0.0,
        },
        quotation: {
          price: 0.0,
          costExplanation: null,
          links: [],
        },
        expeditionDate: null,
        repairDescription: null,
        replacedPartsDescription: null,
        repairCodesDescription: null,
        legitimateComplaint: null,
      },
    },

    doc: {
      identifier: 0,
      caseNumber: null,
      sn_imei: null,
      sn_imei_new: null,
      status: null,
      substatus: null,
      statusDescription: null,
      productName: null,
      productNumber: null,
      warranty: null,
      result: null,
      shipmentIn: {
        company: null,
        number: null,
      },
      shipmentOut: {
        company: null,
        number: null,
        price: 0.0,
      },
      quotation: {
        price: 0.0,
        costExplanation: null,
        links: [],
      },
      expeditionDate: null,
      repairDescription: null,
      replacedPartsDescription: null,
      repairCodesDescription: null,
      legitimateComplaint: null,
    },
  };

  getTickets = async (type) => {
    this.setState({
      type: type,
      error: { show: false, text: "" },
      loading: true,
    });
    var _res = await Api({
      ...this.props,
      type: "GetData/" + type,
      method: "get",
    });
    if (_res.status === 200) {
      var data = _res.data;
      this.setState({
        error: { show: false, text: "" },
        loading: false,
        tickets: data,
      });
    } else {
      this.setState({
        error: { show: true, text: _res.data.detail },
        loading: false,
      });
    }
  };

  parseDoc = (idx, status) => {
    let doc = this.state.tickets[idx];
    let selectedDoc = this.state.doc;
    selectedDoc.identifier = doc.identifier;
    selectedDoc.status = status;
    this.setState({
      modal_doc: {
        ...this.state.modal_doc,
        data: selectedDoc,
        open: true,
        type: status,
      },
    });
  };

  sentData = async (identifier,status) => {
    this.setState({
      error: { show: false, text: "" },
      loading: true,
    });
    var _res = await Api({
      ...this.props,
      type: "NotifiFromApp/" + identifier + "/" + status,
      method: "get"
    });
    if (_res.status === 200) {
      this.getTickets(this.state.type);
      this.setState({
        error: { show: false, text: "" },
        modal_doc: {
          open: false,
          type: "",
          data: "",
        },
      });
    } else {
      this.setState({
        error: { show: true, text: _res.data.detail },
        loading: false,
      });
    }
  };

  render() {
    const { Bs, VARIANT, SIZE, Icon, Placeholder } = this.props;
    return (
      <>
        {this.state.modal_doc.open && (
          <Bs
            modal
            show={this.state.modal_doc.open}
            onHide={() =>
              this.setState({ modal_doc: { open: false, type: "" } })
            }
            keyboard={false}
            backdrop="static"
            centered
            size={SIZE.LG}
            aria-labelledby="contained-modal-title-vcenter"
          >
            <Bs modalheader closeButton>
              Odeslat status {this.state.modal_doc.type}
            </Bs>
            {this.state.error.show && (
              <Bs alert variant={VARIANT.DANGER}>
                <Bs small>{this.state.error.text}</Bs>
              </Bs>
            )}
            <Bs modalfooter className="d-flex justify-content-end">
              <Bs
                button
                variant={VARIANT.SUCCESS}
                size={SIZE.SM}
                disabled={this.state.loading}
                onChange={(e) =>
                  this.setState({
                    modal_doc: {
                      ...this.state.modal_doc,
                      data: JSON.parse(e.target.value),
                    },
                  })
                }
                onClick={this.sentData}
              >
                {this.state.loading ? <Bs brtxspin /> : "Odeslat"}
              </Bs>
            </Bs>
          </Bs>
        )}

        <Bs row className="mb-4">
          <Bs card bg="uni">
            <Bs cardbody>
              <Bs row>
                <Bs col xs={12} lg={6}>
                  <Bs
                    badge
                    pill
                    bg={VARIANT.CUSTOM}
                    onClick={() => this.setState({ selectGroup: 0 })}
                    className={
                      this.state.selectGroup === 0
                        ? "active-badge c-badge me-2 mt-2 mb-2 cursor-pointer"
                        : "c-badge me-2 mt-2 mb-2 cursor-pointer"
                    }
                  >
                    Chyby{" "}
                    <Bs badge pill bg={VARIANT.DANGER} className="ms-1">
                      {this.state.loading ? (
                        <Bs brtxspin />
                      ) : (
                        this.state.errorTicketCnt
                      )}
                    </Bs>
                  </Bs>
                  <Bs
                    badge
                    pill
                    bg={VARIANT.CUSTOM}
                    onClick={() => {
                      this.setState({ selectGroup: 1 });
                      this.getTickets("GET_ALL_OPEN");
                    }}
                    className={
                      this.state.selectGroup === 1
                        ? "active-badge c-badge me-2 mt-2 mb-2 cursor-pointer"
                        : "c-badge me-2 mt-2 mb-2 cursor-pointer"
                    }
                  >
                    Otevřené{" "}
                    <Bs badge pill bg={VARIANT.SUCCESS} className="ms-1">
                      {this.state.loading ? (
                        <Bs brtxspin />
                      ) : (
                        this.state.successTicketCnt
                      )}
                    </Bs>
                  </Bs>
                  <Bs
                    badge
                    pill
                    bg={VARIANT.CUSTOM}
                    onClick={() => {
                      this.setState({ selectGroup: 2 });
                      this.getTickets("GET_ALL_NEW");
                    }}
                    className={
                      this.state.selectGroup === 2
                        ? "active-badge c-badge me-2 mt-2 mb-2 cursor-pointer"
                        : "c-badge me-2 mt-2 mb-2 cursor-pointer"
                    }
                  >
                    Nové{" "}
                    <Bs badge pill bg={VARIANT.PRIMARY} className="ms-1">
                      {this.state.loading ? (
                        <Bs brtxspin />
                      ) : (
                        this.state.openTicketCnt
                      )}
                    </Bs>
                  </Bs>
                </Bs>
                <Bs col xs={12} lg={6} className="d-flex justify-content-end">
                  <Bs formcontrol placeholder="filtrovat" />
                </Bs>
              </Bs>
            </Bs>
          </Bs>
        </Bs>
        <>
          {this.state.loading && (
            <Bs card bg={VARIANT.WHITE}>
              <Bs modalbody>
                <Bs row>
                  <Bs col xs={4}>
                    <Placeholder
                      line={[
                        {
                          itms: [
                            {
                              size: 7,
                            },
                            {
                              size: 3,
                            },
                          ],
                        },
                      ]}
                    />
                  </Bs>
                </Bs>
              </Bs>
            </Bs>
          )}
          {!this.state.loading && (
            <>
              {this.state.tickets.map((e, idx) => (
                <>
                  <Bs row className="mb-2">
                    <Bs card bg={VARIANT.WHITE} className={""}>
                      <Bs cardbody>
                        <Bs row>
                          <Bs col xs={10} lg={5}>
                            <Bs row className="d-flex">
                              <Bs span>
                                <Icon
                                  aioutlineinfocircle
                                  className="c-secondary me-2 fs-20"
                                  data-tip={e.symptomDescription}
                                />
                                <Bs strong className="me-4">
                                  {e.caseNumber}
                                </Bs>
                                <Bs small className="ms-4 text-muted">
                                  {e.status}
                                </Bs>
                                <Bs small className="ms-4 text-muted">
                                  ({"Vytvořeno: " + e.caseCreateDate})
                                </Bs>
                              </Bs>
                            </Bs>
                            <Bs row>
                              <Bs small className="o-el" data-tip={"e.ErrorST"}>
                                {e.vendor} - {e.productName}
                              </Bs>
                            </Bs>
                          </Bs>
                          <Bs
                            col
                            xs={3}
                            className="d-flex justify-content-center align-items-center"
                          >
                            <Bs dropdown>
                              <Bs
                                dropdowntoggle
                                variant={VARIANT.LIGHT}
                                className="pt-2"
                                data-tip={
                                  e.identifier ? "LOS č.: " + e.identifier : ""
                                }
                              >
                                <Icon
                                  gideertrack
                                  className={
                                    e.identifier
                                      ? "fs-20 c-success"
                                      : "fs-20 text-muted"
                                  }
                                />
                              </Bs>
                              <Bs dropdownmenu className="p-2">
                                <Bs dropdownheader>LOS ID</Bs>
                                {e.identifier && (
                                  <Bs
                                    dropdownitem
                                    eventKey="2"
                                    onClick={() => {
                                      window.navigator.clipboard.writeText(
                                        e.identifier
                                      );
                                      this.props.setToast(
                                        "Číslo LOS bylo zkopírováno do schránky.",
                                        "Schránka",
                                        "secondary"
                                      );
                                    }}
                                  >
                                    Kopírovat do schránky LOS ID
                                  </Bs>
                                )}
                                <Bs dropdownheader>CASENUMBER ID</Bs>
                                {e.identifier && (
                                  <Bs
                                    dropdownitem
                                    eventKey="2"
                                    onClick={() => {
                                      window.navigator.clipboard.writeText(
                                        e.caseNumber
                                      );
                                      this.props.setToast(
                                        "Číslo LOS bylo zkopírováno do schránky.",
                                        "Schránka",
                                        "secondary"
                                      );
                                    }}
                                  >
                                    Kopírovat do schránky CASENUMBER
                                  </Bs>
                                )}
                              </Bs>
                            </Bs>
                            <Bs dropdown>
                              <Bs
                                dropdowntoggle
                                variant={VARIANT.LIGHT}
                                className="pt-2"
                                data-tip={"Dodané příslušenství"}
                              >
                                <Icon
                                  vscpackage
                                  className={
                                    JSON.parse(e?.accessories_accessory)?.length >
                                    0
                                      ? "fs-20 c-success"
                                      : "fs-20 text-muted"
                                  }
                                />
                              </Bs>
                              <Bs dropdownmenu className="p-2">
                                {JSON.parse(e?.accessories_accessory)?.map(
                                  (a) => (
                                    <Bs dropdownheader>
                                      {a.name} ({a.qty})
                                    </Bs>
                                  )
                                )}
                              </Bs>
                            </Bs>
                            <Icon
                              aioutlinedollar
                              className={
                                e.decision === "Yes"
                                  ? "ms-2 fs-20 c-success"
                                  : e.decision === "No"
                                  ? "ms-2 fs-20 c-danger"
                                  : e.quotation_price ? "ms-2 fs-20 c-info" :"ms-2 fs-20 text-muted"
                              }
                              data-tip={
                                e.decision === "Yes"
                                  ? "Schválená cenová nabídka</br></br>CZK " +
                                    e.price +
                                    " s DPH"
                                  : e.decision === "No"
                                  ? "Zamítnutá cenová nabídka</br></br>CZK " +
                                    e.price +
                                    " s DPH"
                                  : e.quotation_price ? "Vystavena cenová nabídka" : "Bez cenové nabídky"
                              }
                            />
                            <Icon
                              iobarcode
                              className="ms-3 fs-20 c-secondary cursor-pointer"
                              onClick={() => {
                                window.navigator.clipboard.writeText(
                                  e.sn_imei
                                );
                                this.props.setToast(
                                  "IMEI bylo zkopírováno do schránky.",
                                  "Schránka",
                                  "secondary"
                                );
                              }}
                              data-tip={
                                e.sn_imei
                              }
                            />
                            <Icon
                              mdoutlinelocalshipping
                              className="ms-3 fs-20 c-secondary cursor-pointer"
                              onClick={() => {
                                window.navigator.clipboard.writeText(
                                  e.transport_trackingNumber
                                );
                                this.props.setToast(
                                  "Číslo dopravy bylo zkopírováno do schránky.",
                                  "Schránka",
                                  "secondary"
                                );
                              }}
                              data-tip={
                                e.transport_company + '<br></br>' + e.transport_trackingNumber
                              }
                            />
                            <Icon
                              mdoutlinereceipt
                              className="ms-3 fs-20 c-secondary cursor-pointer"
                              onClick={() => {
                                window.navigator.clipboard.writeText(
                                  e.DocNo
                                );
                                this.props.setToast(
                                  "Číslo zakázky BRITEX bylo zkopírováno do schránky.",
                                  "Schránka",
                                  "secondary"
                                );
                              }}
                              data-tip={
                                e.DocNo + '<br></br>' + e.DocStatus
                              }
                            />
                          </Bs>
                          {e.DocNo > 0 && (
                            <Bs col xs={4} className="d-flex justify-content-end">
                            <Bs dropdown>
                              <Bs
                                dropdowntoggle
                                variant={VARIANT.LIGHT}
                                className="pt-2"
                                data-tip={"Akce"}
                              >
                                <Icon
                                  ioellipsisvertical
                                  className={"fs-20 text-muted"}
                                />
                              </Bs>
                              <Bs dropdownmenu className="p-2">
                                <Bs dropdownheader>Dostupné akce</Bs>
                                <Bs
                                  dropdownitem
                                  eventKey="2"
                                  onClick={() => {
                                    this.sentData(e.identifier, "CO");
                                  }}
                                >
                                  CO - přijato do servisu
                                </Bs>
                                <Bs
                                  dropdownitem
                                  eventKey="2"
                                  onClick={() => {
                                    this.sentData(e.identifier, "LG");
                                  }}
                                >
                                  LG - zalogováno
                                </Bs>
                                <Bs
                                  dropdownitem
                                  eventKey="2"
                                  onClick={() => {
                                    this.sentData(e.identifier, "NC");
                                  }}
                                >
                                  NC - chybí informace
                                </Bs>
                                <Bs
                                  dropdownitem
                                  eventKey="2"
                                  onClick={() => {
                                    this.sentData(e.identifier, "QA");
                                  }}
                                >
                                  QA - cenová nabídka
                                </Bs>
                                <Bs
                                  dropdownitem
                                  eventKey="2"
                                  onClick={() => {
                                    this.sentData(e.identifier, "RW");
                                  }}
                                >
                                  RW - pracuje se
                                </Bs>
                                <Bs
                                  dropdownitem
                                  eventKey="2"
                                  onClick={() => {
                                    this.sentData(e.identifier, "RC");
                                  }}
                                >
                                  RC - hotovo, opraveno - výměnou dílu
                                </Bs>
                                <Bs
                                  dropdownitem
                                  eventKey="2"
                                  onClick={() => {
                                    this.sentData(e.identifier, "FT");
                                  }}
                                >
                                  FT - po final testu
                                </Bs>
                                <Bs
                                  dropdownitem
                                  eventKey="2"
                                  onClick={() => {
                                    this.sentData(e.identifier, "DP");
                                  }}
                                >
                                  DP - odesláno/ předáno
                                </Bs>
                                <Bs
                                  dropdownitem
                                  eventKey="2"
                                  onClick={() => {
                                    this.sentData(e.identifier, "DL");
                                  }}
                                >
                                  DL - odesláno/ předáno
                                </Bs>
                                <Bs
                                  dropdownitem
                                  eventKey="2"
                                  onClick={() => {
                                    this.sentData(e.identifier, "CN");
                                  }}
                                >
                                  CN - storno
                                </Bs>
                              </Bs>
                            </Bs>
                          </Bs>
                          )}
                        </Bs>
                      </Bs>
                    </Bs>
                  </Bs>
                </>
              ))}
            </>
          )}
        </>
      </>
    );
  }
}
